export default {
  namespaced: true,

  state: {
    current: 'vi',
    available: ['vi', 'en'],
  },

  mutations: {
    SET_LOCALE(state, locale) {
      if (state.available.includes(locale)) {
        state.current = locale;
        localStorage.setItem('landing_locale', locale);
      }
    },
  },

  actions: {
    changeLocale({ commit, dispatch }, locale) {
      commit('SET_LOCALE', locale);
      // Reload content when locale changes
      dispatch('home/fetchContent', locale, { root: true });
    },

    initLocale({ commit }) {
      const savedLocale = localStorage.getItem('landing_locale') || 'vi';
      commit('SET_LOCALE', savedLocale);
    },
  },

  getters: {
    current: state => state.current,
    available: state => state.available,
  },
};
